/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import { C11nEnv } from '../interpreter/c11n-env';

export const resolveParagraphContent = (paragraphContent: string, c11nEnv: C11nEnv, category?: string) => {
  if (!paragraphContent) {
    return paragraphContent;
  }
  const localParagraphContent = new DOMParser().parseFromString(paragraphContent, 'text/html');
  const referenceTagList = localParagraphContent.querySelectorAll('pega-reference');
  for (const referenceTag of referenceTagList) {
    const property = referenceTag.getAttribute('data-rule-id');
    if (property) {
      const resolvedProperty = c11nEnv.getValue(property);
      const propertyTextNode = localParagraphContent.createTextNode(resolvedProperty ?? '');
      referenceTag.replaceWith(propertyTextNode);
      c11nEnv.registerAdditionalProps({ [property]: `@P ${property}` });
    } else {
      referenceTag.replaceWith('');
    }
  }
  let resolvedContent;
  if (category === 'simple') {
    resolvedContent = localParagraphContent?.body?.textContent || '';
  } else {
    resolvedContent = localParagraphContent?.body?.innerHTML || '';
  }
  const isEmptyParagraphTag = /^(<p>)\s*(<\/p>)$/.test(resolvedContent);
  if (isEmptyParagraphTag) {
    // If content resolves to empty paragraph tag, return null so that no visual gap shows in UI
    return null;
  }
  return resolvedContent;
};
